import { useEffect, useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Table from '../../../core/common/dataTable/index'
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';
import SearchSelect from '../../../core/common/search-select/searchSelect';
import CommonSelect2 from '../../../core/common/commonSelect2';

// import { Modal, Button } from "antd";
import { Modal, Button, Card, Row, Col, Tag, Divider } from "antd";


const StaffList = () => {
    const [loading, setLoading] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState<any>(null)
    const [isModalOpen, setIsModalOpen] = useState<any>(false);
    const [ViewStaffData, setViewStaffData] = useState<any>([])
    const routes = all_routes;
    const [orgStaff, setOrgStaff] = useState<any>([])
    const organizationId = localStorage.getItem("organization_id")


//     useEffect(()=>{
// console.log(ViewStaffData, "ViewStaffData...........")
//     }, [ViewStaffData])

    const getAllProperty = async () => {
        const payload = {
            organization_id: organizationId,
            category_code: "SERVICESTAFF",
            dashboard: "true"
        }
        try {
            setLoading(true)
            const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.GET_ORG_PROPERTY, payload)
            console.log("property data vvvvvvvv", response?.data)
            if (response?.success) {
                const result = response?.data
                setOrgStaff(result)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllProperty();
    }, [])

    const viewOrgStaff = async (staffId: any) => {
        const payload = {
            "staffId": staffId
        }
        setLoading(true)
        try {
            const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.VIEW_ORG_STAFF, payload)
            if (response?.success) {
                // setViewStaffData(response?.data[0])
                setViewStaffData({
                    ...response?.data[0],
                    properties: response?.data[0].properties || [],
                    subtypes: response?.data[0].subtypes || []
                });
                setIsModalOpen(true);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            title: "Staff Id",
            dataIndex: "staff_id",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.staff_id || "").localeCompare(b.staff_id || ""),
        },
        {
            title: "Service  Name",
            dataIndex: "service_name",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.service_name || "").localeCompare(b.service_name || ""),
        },
        {
            title: "Full Name",
            dataIndex: "full_name",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.full_name || "").localeCompare(b.full_name || ""),
        },
        {
            title: "Category Name",
            dataIndex: "category_name",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.category_name || "").localeCompare(b.category_name || ""),
        },
        {
            title: "Contact",
            dataIndex: "contact_number",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.contact_number || "").localeCompare(b.contact_number || ""),
        },
        {
            title: "Assigned Properties",
            dataIndex: "action",
            render: (_: any, record: any) => (
                <div className="d-flex align-items-center">
                    <i
                        className="fas fa-eye"
                        style={{ cursor: "pointer", paddingLeft: "15px" }}
                        onClick={() => {
                            // setSelectedItemId(record.staff_id);
                            viewOrgStaff(record.staff_id);
                        }}
                    ></i>
                </div>
            ),
        }
    ];
    return (
      <>
        {/* === Staff Details Modal === */}
        <div
          className="modal fade show custom-staff-modal"
          style={{ display: isModalOpen ? "block" : "none" }}
          tabIndex={-1}
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title">Assigned Properties</h5> */}
                <h5 className="modal-title">{ViewStaffData?.full_name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>

              <div className="modal-body">
                {ViewStaffData ? (
                  <>
                    {/* 📝 Basic Information */}
                    {/* <div className="section-card mb-4">
                                        <h6 className="section-title">📝 Basic Information</h6>
                                        <div className="row">
                                            {[
                                                { label: "Full Name", value: ViewStaffData.full_name },
                                                { label: "Gender", value: ViewStaffData.gender },
                                                { label: "Contact", value: ViewStaffData.contact_number },
                                                { label: "Category", value: ViewStaffData.category_name },
                                                { label: "Service Name", value: ViewStaffData.service_name },
                                                { label: "Staff ID", value: ViewStaffData.staff_id },
                                                { label: "Organization ID", value: ViewStaffData.organization_id },
                                                { label: "Category Code", value: ViewStaffData.category_code },
                                                { label: "Staff Service ID", value: ViewStaffData.staff_service_id },
                                            ].map((item, index) => (
                                                <div className="col-12 col-sm-6 col-md-4 mb-2" key={index}>
                                                    <div className="label-value">
                                                        <strong>{item.label}:</strong>
                                                        <div>{item.value ?? "-"}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div> */}
                    {/* 🏠 Assigned Properties */}
                    <div className="section-card mb-4">
                      <h6 className="section-title">Assigned Properties</h6>
                      <div className="assigned-table-container">
                        {Array.isArray(ViewStaffData.properties) &&
                        ViewStaffData.properties.length > 0 ? (
                          <table className="assigned-table">
                            <thead>
                              <tr>
                                <th>Property Name</th>
                                <th>Block No</th>
                                <th>Locality</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Pincode</th>
                                {/* <th>Property ID</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {ViewStaffData.properties.map((prop: any) => (
                                <tr key={prop.property_id}>
                                  <td>{prop.property_name ?? "-"}</td>
                                  <td>{prop.house_flat_block_no ?? "-"}</td>
                                  <td>{prop.locality ?? "-"}</td>
                                  <td>{prop.city ?? "-"}</td>
                                  <td>{prop.state ?? "-"}</td>
                                  <td>{prop.pincode ?? "-"}</td>
                                  {/* <td>{prop.property_id ?? "-"}</td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center text-muted">
                            No assigned properties found.
                          </p>
                        )}
                      </div>
                    </div>
                    {/* 🧹 Sub Services */}
                    {/* <div className="section-card">
                      <h6 className="section-title">🧹 Sub Services</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {Array.isArray(ViewStaffData.subtypes) &&
                        ViewStaffData.subtypes.length > 0 ? (
                          ViewStaffData.subtypes.map((sub: any) => (
                            <span
                              className="abb"
                              key={sub.staff_sub_service_id}
                            >
                              {sub.sub_service_name}
                            </span>
                          ))
                        ) : (
                          <p className="text-center text-muted">
                            No sub services assigned.
                          </p>
                        )}
                      </div>
                    </div> */}
<div className="section-card">
  <h6 className="section-title">Sub Services</h6>
  {Array.isArray(ViewStaffData.subtypes) && ViewStaffData.subtypes.length > 0 ? (
    <ul className="subservices-grid">
      {ViewStaffData.subtypes.map((sub: any) => (
        <li key={sub.staff_sub_service_id}>
          <span className="check-bullet">✔</span> {sub.sub_service_name}
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-center text-muted">No sub services assigned.</p>
  )}
</div>



                  </>
                ) : (
                  <p>Loading...</p>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setIsModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Staff Details</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Dashboard</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Staff Details
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                {/* <Link to={routes.AllOrganizations}>
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-arrow-left me-2" />
                                    Back
                                </button>
                            </Link> */}
              </div>
            </div>
            {/* /Breadcrumb */}

            {/* <div className="col-md-12 mb-3 bg-white border p-3 shadow-sm rounded-3">
                        <label className='pb-2 fw-medium fs-15 d-block'>Select Organization:</label>
                        <CommonSelect2 className='d-inline ' options={options_organization} name='organization' defaultValue={orgId} onChange={(e: any) => setOrgId(e?.value)} styles={{ maxWidth: "500px" }} />
                        <button className='btn btn-primary px-3 ms-2' onClick={searchProperties}> <i className="bi bi-search me-sm-1"></i><span className='d-none d-sm-inline'>Search</span></button>
                    </div> */}

            {/* Performance Indicator list */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Staff List</h5>
              </div>
              <div className="card-body p-0">
                {loading ? (
                  <Loading />
                ) : (
                  <Table
                    dataSource={orgStaff}
                    rowKeyId={"Staff_id"}
                    columns={columns}
                    Selection={false}
                  />
                )}
              </div>
            </div>
            {/* /Performance Indicator list */}
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
            <p className="mb-0">
              © {new Date().getFullYear()} Nestfin Technology. All rights reserved.
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    );
}

export default StaffList;